import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import {Router} from '@angular/router';
import {CookieService} from 'ngx-cookie';
import {AuthService} from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(public router: Router, private auth: AuthService, private _cookieService: CookieService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const auth_token = this._cookieService.get('auth_token');
    if (!auth_token) {
      return true;
    }

    return this.auth.getProfile().toPromise()
      .then(() => {
        const role = this.auth.hasRole();
          switch (role) {
            case 5:
              this.router.navigate(['/admin']);
              return false;
            case 2:
              this.router.navigate(['/']);
              return false;
            default :
              this.router.navigate(['/login']);
              return false;
          }
      })
      .catch(() => true);

  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.guard.ts